<template>
<div class="main-container">
  <div class="table-btn">
    <a-checkbox @change="onClick" ref="checkbox">
    当页全选
    </a-checkbox>
    <a-button @click="markRead">标记已读</a-button>
  </div>

  <a-table 
  :locale="{
    emptyText: '暂无数据'
  }"
    rowKey="id" 
    :columns="columns" 
    :data-source="data" 
    :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
    @change="handleTableChange" 
    :pagination="pagination"  
    style="margin-top: 12px;" >
    <span slot="status" slot-scope="text">
      <span class="span" v-show="text=='0'"><i class="tip"></i></span>
      {{text|statusF}}
    </span>
  </a-table>

</div>
  
</template>
<script>
import page from "@/assets/mixin/page.js";
const columns = [
  {
    title: '消息内容',
    dataIndex: 'message',
    key: 'message',
    ellipsis: true,
    width:'70%',
  },{
    title: '时间',
    key: 'sendDateTimeLabel',
    dataIndex: 'sendDateTimeLabel',
    width:'20%',
  },{
    title: '状态',
    dataIndex: 'status',
    key: 'status',
    width:'10%',
    scopedSlots: { customRender: 'status' },
  }
];

export default {
  mixins: [page],
  data() {
    return {
      data:[],
      selectedRowKeys: [],
      columns,
    };
  },
  created(){
    this.getdata()
  },
   computed: {
    hasSelected() {
      return this.selectedRowKeys.length > 0;
    },
  },
  filters:{
    statusF(value){
      switch (value) {
        case 0: return "未读";break;
        case 1: return "已读";break;
      }
    }
  },
  methods:{
    checkSelectedisEmpty(index){
      if (this.selectedRowKeys.length==0) {
        this.$message.warning("请先选择消息！");
        return true;
      }else{
        let rows = [];//商品id、状态集合
        let selectedRowKeys = []//选中符合状态的商品
        this.data.map(item =>{
          rows[item.id] = item.status;
        })

        this.selectedRowKeys.map(item=>{
          if (rows[item] ==index ) {
            selectedRowKeys.push(item);
          }
        })
        if (selectedRowKeys.length==0) {
          this.$message.warning('当前选中的消息无状态可更改！')
          return true; 
        }else{
          if (this.selectedRowKeys.length>selectedRowKeys.length) {
            this.$message.info('选中消息中状态不可更改项已帮您去除')
          }
          this.selectedRowKeys = selectedRowKeys;
          return false;
        }
      }
    },
    markRead(){
      if (this.checkSelectedisEmpty(0)) {
        return
      }
      this.$http.post('/notification/setReaded',this.selectedRowKeys).then(res=>{
        // this.$message.info(res.message);
        this.getdata();
      })
    },
    onClick(e){
      let selectedRowKeys = [];
      if ( e.target.checked) {
        this.data.map((item)=>{
          selectedRowKeys.push(item.id)
        }) 
      }
      this.selectedRowKeys = selectedRowKeys;
    },
    getdata(){
      this.selectedRowKeys=[];
      let params = {}
      params.pageNum = this.pagination.current;
      this.$http.post('notification/queryRecordList',params).then(res=>{
        this.data = res.rows;
        this.pagination.total = res.count;
      })
    },
    onSelectChange(selectedRowKeys) {
      // console.log('selectedRowKeys changed: ', selectedRowKeys);
      this.selectedRowKeys = selectedRowKeys;
    },
  }
};
</script>
<style lang="less" scoped>
// { background: '#fff',padding: '24px', marginLeft: '24px',marginBottom:'24px'}
.search-box{
  padding: 29px 24px;
  margin-bottom: 24px;
  background-color: rgb(247, 248, 249);
  label{
    display:inline-block;
    width: 98px;
    text-align: right;
  }
  .search-item{
    display: inline-block;
    margin-bottom: 16px;
  }
  .search-btn{
    margin-left: 98px;
    .ant-btn{
      margin-right: 8px;
    }
    
  }
  .ant-select{
    width: 216px;
  }
  .ant-input{
    width: 216px;
    margin-right: 28px;
  }
}
.table-btn{
  .ant-btn{
    margin-right: 12px;
  }
}
.ant-checkbox-wrapper{
  margin:0 24px;
  /deep/.ant-checkbox{
    margin-right: 16px;
  }
}


.span {
	position:relative;
	padding:5px;
}
.tip {
	display:block;
	background:#f00;
	border-radius:50%;
	width:8px;
	height:8px;
	top:10px;
	right:10px;
	position:absolute;
}

</style>
